import { render, staticRenderFns } from "./DetailTemuanEmas.vue?vue&type=template&id=60f9aa02&scoped=true&"
import script from "./DetailTemuanEmas.vue?vue&type=script&lang=js&"
export * from "./DetailTemuanEmas.vue?vue&type=script&lang=js&"
import style0 from "./DetailTemuanEmas.vue?vue&type=style&index=0&id=60f9aa02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9aa02",
  null
  
)

export default component.exports